<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div
          class="
            weui-cell weui-cell_active weui-cell_select weui-cell_select-after
          "
          slot="in_type"
        >
          <div class="weui-cell__hd">
            <span class="weui-label">{{
              customLabel.in_type || "询价方式"
            }}</span>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.in_type"
              @change="onInTypeChange"
              :disabled="form.main.id"
            >
              <option :value="'公共询价'">公共询价</option>
              <option :value="'定向询价'">定向询价</option>
            </select>
          </div>
        </div>
        <date-field slot="in_startdate" :label="customLabel.in_startdate || '询价日期'"  v-model="form.main.in_startdate" />
        <date-field slot="in_enddate" :label="customLabel.in_enddate || '截止日期'"  v-model="form.main.in_enddate" />
        <bom-field slot="in_bomcode" v-if="isMake" @select="onSelectBom" v-model="form.main.in_bomcode"></bom-field>
        <div class="weui-cell" slot="in_bomqty" v-if="isMake" key="in_bomqty">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
            customLabel.in_bomqty || "套数"
          }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.in_bomqty"
              @change="onBomQtyChange"
              placeholder="请填写"
            />
          </div>
        </div>
        <custom-field
          :label="customLabel.in_text1 || '自定义字段1'"
          v-model="form.main.in_text1" :caller="caller" fieldName="in_text1"
          slot="in_text1" hidden="true"
        />
          <custom-field
            :label="customLabel.in_text2 || '自定义字段2'"
            v-model="form.main.in_text2" :caller="caller" fieldName="in_text2"
            slot="in_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.in_text3 || '自定义字段3'"
            v-model="form.main.in_text3" :caller="caller" fieldName="in_text3"
            slot="in_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.in_text4 || '自定义字段4'"
            v-model="form.main.in_text4" :caller="caller" fieldName="in_text4"
            slot="in_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.in_text5 || '自定义字段5'"
            v-model="form.main.in_text5" :caller="caller" fieldName="in_text5"
            slot="in_text5" hidden="true"
          />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <product-field
            v-model="item.productDTO.pr_detail"
            @select="onSelectProduct($event, item)"
            :label="customLabel.pr_detail"
            slot="pr_detail"
          />
          <div class="weui-cell" v-if="item.ind_prodcode" slot="ind_prodcode" key="ind_prodcode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.ind_prodcode || "物料编号"
            }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.ind_prodcode }}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_orispeccode" slot="pr_orispeccode" key="pr_orispeccode">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ item.productDTO.pr_orispeccode }}
            </div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_brand" slot="pr_brand" key="pr_brand">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.pr_brand || "厂家/品牌"
            }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_brand }}</div>
          </div>
          <div class="weui-cell" slot="ind_planqty" key="ind_planqty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.ind_planqty || "需求数量"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.ind_planqty"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
          </div>
          <vendor-field
            slot="ind_vendname"
            :label="customLabel.ind_vendname || '供应商'"
            v-if="form.main.in_type == '定向询价'"
            v-model="item.ind_vendname"
            @select="onSelectVendor($event, item)"
          />
          <div class="weui-cell" v-if="item.ind_contact" slot="ind_contact" key="ind_contact">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.ind_contact || "联系人"
            }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.ind_contact }} {{ item.ind_tel }}</div>
          </div>
          <currency-field
            slot="ind_currency"
            :label="customLabel.ind_currency || '币种'"
            v-model="item.ind_currency"
            @select="onSelectCurrency($event, item)"
          />
          <div class="weui-cell" slot="ind_taxrate" key="ind_taxrate">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.ind_taxrate || "税率"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.ind_taxrate"
                placeholder="请填写"
              />
            </div>
          </div>
          <file-field v-model="form.main.ind_attach" />
          <div class="weui-cell" slot="ind_remark" key="ind_remark">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
              customLabel.ind_remark || "备注"
            }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="item.ind_remark"
                placeholder="请填写"
              />
            </div>
          </div>
          <custom-field 
            :label="customLabel.ind_text1 || '自定义字段1'"
            v-model="item.ind_text1" :caller="caller" fieldName="ind_text1"
            slot="ind_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.ind_text2 || '自定义字段2'"
            v-model="item.ind_text2" :caller="caller" fieldName="ind_text2"
            slot="ind_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.ind_text3 || '自定义字段3'"
            v-model="item.ind_text3" :caller="caller" fieldName="ind_text3"
            slot="ind_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.ind_text4 || '自定义字段4'"
            v-model="item.ind_text4" :caller="caller" fieldName="ind_text4"
            slot="ind_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.ind_text5 || '自定义字段5'"
            v-model="item.ind_text5" :caller="caller" fieldName="ind_text5"
            slot="ind_text5" hidden="true"
          />
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import DateField from "@/components/field/DateField.vue";
import BomField from "@/components/field/BomField.vue";
import ProductField from "@/components/field/ProductField.vue";
import VendorField from "@/components/field/VendorField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import FileField from "@/components/field/FileField.vue";
import process from "@/mixins/process.js";
import session from "@/util/session.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  components: {
    CustomLayout,
    DateField,
    BomField,
    ProductField,
    VendorField,
    CurrencyField,
    FileField,
    CustomField
  },
  mixins: [process],
  data() {
    const appType = session.getAccount().defaultCompany.app.split('-')[0]
    const isMake = appType == 'make'

    return {
      baseUrl: "/api/purchase/inquiry",
      codeField: "in_code",
      statusField: "in_statuscode",
      caller: "PurchaseInquiry",
      xtype: "purchase-b2b-inquiry-formpanel",
      form: {
        main: {
          in_type: "公共询价",
          in_status: "未审核",
          in_statuscode: "UNAUDITED"
        },
        items: [
          {
            ind_planqty: 0,
            productDTO: {},

            ind_minbuyqty: 0,
            ind_delivery: 0,
            ind_minqty: 8,
            ind_text1: "",
            ind_text2: "",
            ind_text3: "",
            ind_text4: "",
            ind_text5: ""
          }
        ]
      },
      isMake
    };
  },
  methods: {
    onInTypeChange(e) {
      if(e.target.value == "公共询价") {
        this.form.items.forEach(item => {
          item.ind_vendid = null;
          item.ind_vendcode = null;
          item.ind_contact = null;
          item.ind_tel = null;
        })
      }
    },
    onSelectBom(selection) {
      this.form.main.in_bomcode = selection.bo_code
      this.form.main.in_bomid = selection.id

      this.reqByBom(selection.bo_mothercode)
    },
    onBomQtyChange($event) {
      const qty = $event.target.value

      this.form.items.forEach(item => {
        item.ind_planqty = qty
      })
    },
    onSelectProduct(selection, item) {
      item.productDTO = Object.assign({}, selection);

      item.ind_prodcode = selection.pr_code
      item.ind_prodid = selection.id
    },
    /**
     * 选择供应商
     */
    onSelectVendor(selection, item) {
      item.ind_vendid = selection.id;
      item.ind_vendcode = selection.ve_code;
      item.ind_contact = selection.vc_name;
      item.ind_tel = selection.vc_tel;
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection, item) {
      item.ind_rate = selection.cr_rate;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.in_startdate) {
        me.$weui.topTips("请选择询价日期", 2000);
      } else if (!main.in_enddate) {
        me.$weui.topTips("请选择截止日期", 2000);
      } else {
        var count = 0
        items.forEach(function (item) {
          if (!item.ind_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (main.in_type == '定向询价' && !item.ind_vendid) {
            me.$weui.topTips(`第${count + 1}行供应商未选择`, 2000);
            return false;
          } else {
            count++;
            item.ind_detno = count;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        ind_planqty: 0,
        productDTO: {}
      });
    },
    /**
     * 预启动流程
     * @param {*} caller 
     * @param {*} dto 
     * @param {*} xtype 
     * @param {*} callback 
     */
    preLaunchProcess(caller, dto, xtype, callback) {
        var me = this;
        me.$loading({
            method: "post",
            url: "/api/process/instance/pre_launch",
            jsonData: {
                bizType: caller,
                bizId: dto.id,
                bizCode: dto.code,
                viewType: xtype
            }
        }).then(function (res) {
            if (res.success) {
                if (res.data.launched) {
                    me.$weui.toast("保存成功", 2000);
                    callback.call(me, dto);
                } else {
                    me.selectNodeHandler(res.data.items, function (selectedUserMap) {
                        me.launchProcess(caller, dto, selectedUserMap, xtype, callback);
                    });
                }
            } else if (res.code == 80001) {
                me.$weui.toast("保存成功", 2000);
                // 无流程规则的情况
                callback.call(me, dto);
            } else {
                me.$weui.topTips(res.message, 3000);
                callback.call(me, dto);
            }
        });
    },
    reqByBom(code) {
      var me = this;
      me.$loading({
        url: "/api/purchase/inquiry/inquiryByBom",
        method: "post",
        jsonData: {
          prodCode: code,
          inquiryType: me.form.main.in_type
        }
      }).then(function (res) {
        if(res.success && res.data.length) {
          me.form.items = []
          res.data.forEach((item, index) => {

            me.form.items.push({
              ind_detno: index + 1,
              ind_minbuyqty: 0,
              ind_minqty: 0,
              ind_planqty: 0,
              ind_prodcode: item.ind_prodcode,
              ind_prodid: item.ind_prodid,
              productDTO: {
                pr_detail: item.pr_detail,
                pr_orispeccode: item.pr_orispeccode,
                pr_brand: item.pr_brand,
                pr_unit: item.pr_unit
              }
            })
          })
        }
      });
    }
  },
};
</script>